import Axios from 'axios'
import Vue from 'vue'
import VueI18n from 'vue-i18n'

import Storage from '@/helpers/storage'
import moduleI18N from '@/modules/i18n'

import {configuration} from '../configuration'

Vue.use(VueI18n)


const backwardLanguage = configuration.languages.backwardLanguage


function updateLang() {

    const urlLang = moduleI18N.getLangFromUrl()

    const startLang = urlLang
        || Storage.getItem('lang')
        || getLangFromNavigator()
        || configuration.defaultLanguage

    const goodLang = configuration.languages.all.indexOf(startLang) > -1 ? startLang : configuration.defaultLanguage

    Storage.setItem('lang', goodLang)

    return goodLang

}

function getLangFromNavigator() {
    const lang = window.navigator.userLanguage || window.navigator.language
    if (lang.indexOf('-') === -1) {
        return backwardLanguage[lang.split('-')[0]] || ''
    } else {
        return configuration.languages.all.indexOf(lang) > -1
            ? lang
            : ''
    }
}


async function getConfigs() {

    const lang = updateLang()

    const importEn = await Axios({
        method: 'get',
        headers: { 'content-type': 'application/json'},
        url: '/i18n/en.json'
    })
    const messages = {'en-gb': importEn.data }
    const locale = lang

    return {
        messages,
        locale,
        fallbackLocale: configuration.defaultLanguage
    }
}

export default new VueI18n(getConfigs())
